export default {
  gpuSnapshot: {
    LOADING: 'Loading data. Current counts are not yet confirmed.',
    UNAVAILABLE: 'Data is temporarily unavailable. Refresh to try again; an empty state cannot be confirmed.',
    STALE: 'Refresh failed. Showing the last successful snapshot; the current state is not confirmed.'
  },
  gpuCapacityWait: {
    QUEUED: 'Waiting for scheduling',
    WAITING_CAPACITY: 'Waiting for resources',
    WARMING: 'Preparing compute resources',
    BACKOFF: 'Resource preparation retry pending',
    CONFIRMING: 'Confirming resource status'
  },
  gpuReplacement: {
    title: 'Instance replacement progress (read-only)',
    scope: 'Shows instance replacement only, not the status of the entire pool or every waiting task.',
    trigger: 'Triggering task: {{id}}',
    updated: 'Status updated: {{time}}',
    retry: 'Next retry no earlier than: {{time}}. This is not a task completion estimate.',
    phase: {
      LOADING: 'Reading status',
      NONE: 'No active replacement',
      DRAINING: 'Draining the original instance',
      REPLACING: 'Replacing the instance',
      WARMING: 'Preparing the replacement instance',
      BACKOFF: 'Waiting to retry',
      CONFIRMING: 'Confirming the replacement result',
      UNAVAILABLE: 'Status cannot be confirmed right now'
    }
  }
};
